import api from '../../../api';
import * as types from '../../../redux/actionTypes';

export function loadKbArticleBegin() {
  return {type: types.LOAD_KB_ARTICLE_BEGIN};
}

export function loadKbArticleSuccess(articleNumber, article) {
  return {type: types.LOAD_KB_ARTICLE_SUCCESS, articleNumber, article};
}

export function loadKbArticletError(error) {
  return {
    type: types.LOAD_KB_ARTICLE_ERROR,
    error
  };
}

export function loadKbArticle(articleNumber) {
  return async function(dispatch) {
    dispatch(loadKbArticleBegin());
    try {
      const article = await api.kb.getArticleByUrlName(articleNumber);
      dispatch(loadKbArticleSuccess(articleNumber, article));
    } catch (error) {
      if (error.status === 404) {
        dispatch(loadKbArticleSuccess(articleNumber, null));
      } else {
        dispatch(loadKbArticletError(error));
      }
    }
  };
}
